
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { element } from '@angular/core/src/render3';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { IngresoActivoFijoFuncionario } from 'src/app/models/RegistroActivoFijoFuncionario.model';
import { RegistroIngSalActivoFijo } from 'src/app/shared/models/registroIngSalActivoFijo.model';
import { DISABLED } from '@angular/forms/src/model';
import { ContenedorActivoFijoVisitanteModel } from 'src/app/models/contenedorActivoFijoVisitante.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ActivoFijoVisitanteModel } from 'src/app/models/activoFijoVisitante.model';
import { HisActivoFijoVisitanteModel, HisActivoFijoVisitantePK } from 'src/app/models/hisActivoFijoVisitante.model';
import { ReporteVisitaModel } from 'src/app/models/reporteVisita.model';
import { ActivoFijoModel } from 'src/app/models/activoFijo.model';
import { Observable, Subject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, filter } from 'rxjs/operators';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { DetalleDominioPK, DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { ingSalActivoFijo } from 'src/app/models/IngSalActivoFijo.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';

@Component({
  selector: 'app-gestion-activo-fijo',
  templateUrl: './gestion-activo-fijo.component.html',
  styleUrls: ['./gestion-activo-fijo.component.scss']
})
export class GestionActivoFijoComponent implements OnInit, OnChanges {

  @Input() funcionario: IngresoActivoFijoFuncionario;
  @Input() informacionTarjeta: ReporteVisitaModel;
  @Input() public activosFijosPorFuncionario: RegistroIngSalActivoFijo;
  @Input() Pantalla: string;
  @Input() activosFijosFuncionarioPropioMen: ingSalActivoFijo[];
  @Input() listaActivos: ActivoFijoModel[];
  @Output() busqueda = new EventEmitter();
  @Output() activoSeleccionado = new EventEmitter();
  @Output() tipoActivo = new EventEmitter();
  @Output() respuesta = new EventEmitter();
  @Output() sedeSeleccionada = new EventEmitter();

  @ViewChild('auto') auto;

  public keyInput = 'valor';
  public consultaActivosfuncionario: RegistroIngSalActivoFijo;
  public ingresarEnPantalla: string;
  public placeholderNumeroSerial: string;
  public placeholderTipoActivo: string;
  public habilitarNumeroSerial: boolean;
  public habilitarButtonEntradaElemento: boolean;
  // atributos de formulario
  public tieneSerial: boolean;
  public numeroSerial: string;
  public marca: string;
  public listaMarcas: any;
  public tipoActivoFijo: string;
  public sede: string;
  public observaciones: string;
  public tipoActivoFijoInput: string;

  public numeroDocumentoVisitante: string;
  public tipoDocumentoVisitante: string;

  public listaTipoActivoFijo: any = [];
  public listaSede: any = [];
  public listaMarca: any;
  public modalOptions: ConfirmationModalOptions;
  public cardOptions: any;

  public banderaIngresoSalidaVisitante;
  public banderaTipoActivoInput;

  public constanteCual: string;
  public valorCual: string;

  selectedItem: any = '';
  inputChanged: any = '';
  wikiItems: any[] = [];
  configuracionAutoComplete: any = { class: 'inputAutoComplete', max: 5, placeholder: '', sourceField: ['marca'] };
  model: any;

  // @ViewChild('instance') instance: NgbTypeahead;
  // focus$ = new Subject<string>();
  // click$ = new Subject<string>();

  // search = (text$: Observable<string>) => {
  //   const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
  //   const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
  //   const inputFocus$ = this.focus$;

  //   return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
  //     map(term => (term === '' ? this.listaMarcas
  //       : this.listaMarcas.filter(v => v.toLowerCase().indexOf(term.toLowerCase()) > -1)).slice(0, 10))
  //   );
  // }

  constructor(
    private urlService: UrlService, private spinner: NgxSpinnerService
    , private spiner: NgxSpinnerService, private global: GlobalService
    , private alertService: AlertService) {
    // this.activosFijosPorFuncionario=[];
    this.placeholderNumeroSerial = ConstantesService.PLACEHOLDER_NUMERO_SERIAL;
    this.placeholderTipoActivo = ConstantesService.PLACEHOLDER_TIPO_ACTIVO;
    this.constanteCual = ConstantesService.OPCION_CUAL;
    this.valorCual = ConstantesService.VALOR_CUAL;
    this.habilitarNumeroSerial = true;
    this.habilitarButtonEntradaElemento = true;
    // bandera para indicar si el componente padre es ingreso o salida del visitante
    this.banderaIngresoSalidaVisitante = false;
    this.banderaTipoActivoInput = false;

    this.informacionTarjeta = new ReporteVisitaModel('', '', '', '', '', '', '', '', '', '', '', '', '', new Date(), '', '', '', '', 0);

    this.tieneSerial = true;
    this.numeroSerial = '';
    this.marca = '';
    this.tipoActivoFijo = '';
    this.cardOptions = new Object();
    this.sede = '';
    this.observaciones = '';
    this.listaTipoActivoFijo = [];
    this.listaSede = [];
    this.tipoActivoFijoInput = '';
    // Datos quemados mientras se obtiene los datos del visitante
    this.tipoDocumentoVisitante = '';
    this.numeroDocumentoVisitante = '';
    this.obtenerTipoActivoFijo();
    this.obtenerSede();

    this.modalOptions =
      new ConfirmationModalOptions('Confirmación', '¿Está seguro de ingresar elemento?',
        'SI', 'NO', 'fas fa-level-up-alt', true, false, 'Ingresar elemento', null, 'btn-secondary');

  }

  cathException(error: string, err?: undefined) {
    this.alertService.generateAlertError(error, ' ');
    this.spiner.hide();
  }

  ngOnChanges(changes: any) {

    if (changes.Pantalla) {
      this.cardOptions.Origen = changes.Pantalla.currentValue/*.Origen*/;
      if (this.cardOptions.Origen === ConstantesService.PANTALLA_INGRESO_SALIDA_FUNCIONARIO
        || this.cardOptions.Origen === ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_ENTRADA) {
        this.banderaIngresoSalidaVisitante = true;
        document.getElementById('registroActivoFijo').classList.remove('disabledTab');
      } else if (this.cardOptions.Origen === ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_SALIDA) {
        this.banderaIngresoSalidaVisitante = false;
        document.getElementById('registroActivoFijo').classList.add('disabledTab');
      }
    }
    if (changes.activosFijosPorFuncionario) {
      this.consultaActivosfuncionario = changes.activosFijosPorFuncionario.currentValue;
    }

    if(changes.activosFijosFuncionarioPropioMen){
      this.activosFijosFuncionarioPropioMen=changes.activosFijosFuncionarioPropioMen.currentValue;
    }

    if (changes.informacionTarjeta) {
      this.informacionTarjeta = changes.informacionTarjeta.currentValue;
    }

    if (changes.listaActivos) {
      this.listaActivos = changes.listaActivos.currentValue;
    }

    if (changes.listaSedes) {
      this.listaSede = changes.listaSedes.currentValue;
    }

    if (changes.funcionario) {

    }

    if(changes.marca){
      this.habilitarButtonEntrada();
    }
  }

  ngOnInit() {
    // this.consultaActivosfuncionario = this.activosFijosPorFuncionario;
    this.ingresarEnPantalla = this.Pantalla;
    this.obtenerMarcasActivoFijo();
    if (this.banderaIngresoSalidaVisitante) {
      this.habilitarDeshabilitarNavegador('REGISTRO');
    } else {
      this.habilitarDeshabilitarNavegador('CONSULTA');
    }
    this.sede = sessionStorage.getItem(ConstantesService.SEDE_DEFECTO_SESSSION);
    this.tipoDocumentoVisitante = this.informacionTarjeta.tipoIdVisitante;
    this.numeroDocumentoVisitante = this.informacionTarjeta.numeroIdVisitante;
  }


  habilitarDeshabilitarNavegador(parametro: string) {
    if (parametro === 'REGISTRO') {
      document.getElementById('registroActivoFijo').classList.add('selectNav');
      document.getElementById('consultaActivoFijo').classList.remove('selectNav');
      document.getElementById('registro').classList.add('show', 'active');
      if (document.getElementById('consulta')) {
        document.getElementById('consulta').classList.remove('show', 'active');
      }
      this.habilitarDeshabilitarRadioButton('REGISTRO');
    } else if (parametro === 'CONSULTA') {
      document.getElementById('consultaActivoFijo').classList.add('selectNav');
      document.getElementById('registroActivoFijo').classList.remove('selectNav');
      document.getElementById('registro').classList.remove('show', 'active');
      document.getElementById('consulta').classList.add('show', 'active');
      this.habilitarDeshabilitarRadioButton('CONSULTA');
    }
  }

  habilitarDeshabilitarRadioButton(parametro: string) {
    if (parametro === 'CONSERIAL') {
      this.placeholderNumeroSerial = 'Incluya número de serial*';
      this.habilitarNumeroSerial = true;
      this.tieneSerial = true;
      this.habilitarButtonEntrada();
    } else if (parametro === 'SINSERIAL') {
      this.numeroSerial = undefined;
      this.placeholderNumeroSerial = 'Número de serial';
      this.habilitarNumeroSerial = false;
      this.tieneSerial = false;
      this.habilitarButtonEntrada();
    }

  }
  // && this.validarSerial()
  //     && (this.tipoActivoFijo && this.tipoActivoFijo != '')
  //     && (this.sede && this.sede != '')

  habilitarButtonEntrada() {
    if (this.tipoActivoFijo == this.valorCual) {
      this.banderaTipoActivoInput = true;
    } else {
      this.banderaTipoActivoInput = false;
    }
    if ((this.marca && this.marca !== '') && this.validarSerial()
      && (this.tipoActivoFijo && this.tipoActivoFijo !== '')
      && (this.sede && this.sede !== '')) {
      this.modalOptions.disabled = false;
      return true;
    } else {
      this.modalOptions.disabled = true;
      return false;
    }
  }

  private validarSerial(): boolean {
    let tieneActivoFijoInput: boolean = true;
    if (this.banderaTipoActivoInput && !this.tipoActivoFijoInput && this.tipoActivoFijoInput === '') {
      tieneActivoFijoInput = false;
    }
    return (!this.tieneSerial || (this.tieneSerial && (this.numeroSerial && this.numeroSerial !== ''))) && tieneActivoFijoInput;
  }

  public obtenerTipoActivoFijo() {
    this.spiner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'TipoActivoFijo']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {
        if (data.length === 0) {
        //  this.cathException('No hay estados de visita disponibles');
        } else {
          this.listaTipoActivoFijo = data;
        }
        this.spiner.hide();
      }, err => {
        this.cathException('No es posible Obtener estados de visita', err);
      }
    );
  }

  public obtenerSede() {
    this.spiner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'Sede']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {
        if (data.length === 0) {
        //  this.cathException('No hay estados de visita disponibles');
        } else {
          this.listaSede = data;
        }
        this.spiner.hide();
      }, err => {
        this.cathException('No es posible Obtener estados de visita', err);
      }
    );
  }

  public obtenerMarcasActivoFijo() {
    this.spiner.show();
    const serviceProvider = 'ObtenerDominio';
    const queryParams: Array<[string, string]> = new Array<[string, string]>();

    queryParams.push(['filterBy=detalleDominioPK.nombreDominio', 'MarcaActivoFijo']);
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);

    this.global.getGenerico(url).subscribe(
      data => {
        if (data.length === 0) {
        //  this.cathException('No hay estados de visita disponibles');
        } else {
          this.listaMarca = data;
          let temp = [];
          if (this.listaMarca.length != 0) {
            this.listaMarca.forEach(element => {
              temp.push(element.valor);
            });
          }
          this.listaMarcas=temp;
        }
        this.spiner.hide();
      }, err => {
        this.cathException('No es posible Obtener estados de visita', err);
      }
    );

  }



  // fromero
  // 15/06/2019
  // metodo de consulta de activo por placa inventario

  consultarActivoFijo(event: any) {
    this.spinner.show();
    let existencia = false;
    const queryParams: Array<[string, string]> = new Array<[string, string]>();
    queryParams.push(['numeroSerialPlaca', event]);
    queryParams.push(['numDocFuncionario', this.funcionario.numeroIdFuncionario]);
    queryParams.push(['tipoDocFuncionario', this.funcionario.tipoIdFuncionario]);
    queryParams.push(['propioMen', DominiosService.ACTIVO_PROPIO]);
    const serviceProvider = 'consultarActivosPropiosMen';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, queryParams), this.urlService.hostAPI_ACCVIS);
    this.global.postGenerico(url).subscribe(
      data => {
        if (data.length > 0) {
          existencia = true;
          this.habilitarDeshabilitarNavegador('CONSULTA');
          this.numeroSerial = '';
          this.alertService.generateAlertError(ConstantesService.ACTIVO_EXITENTE_EN_SISTEMA, '');
        } else {
          this.alertService.generateAlertSuccess(ConstantesService.ACTIVO_NO_EXITENTE_EN_SISTEMA, '');
        }
        this.spinner.hide();
      }, err => {
        this.cathException('No es posible Consultar los activos fijos', err);
      }
    );
    return existencia;
  }



  // damunoz
  // valida la existencia del activo fijo del visitante
  public validarExistenciaActivoFijo() {

    if (this.numeroSerial && this.numeroSerial != null) {
      if (this.Pantalla === ConstantesService.PANTALLA_INGRESO_SALIDA_FUNCIONARIO) {
        this.consultarActivoFijo(this.numeroSerial);
      } else {
        this.spiner.show();
        const serviceProvider = 'ConsultaActivoFijo';
        // let queryParams: Array<[string, string]> = new Array<[string, string]>();
        let existencia = false;
        const consulta =
          `?filterBy=numeroSerial=${this.numeroSerial}%26tipoDocVisitante=${this.tipoDocumentoVisitante}%26numDocVisitante=${this.numeroDocumentoVisitante}`;

        // queryParams.push(['filterBy=numeroSerial', this.numeroSerial]);
        // queryParams.push(['%26tipoDocVisitante=', this.tipoDocumentoVisitante]);
        // queryParams.push(['%26numDocVisitante=', this.numeroDocumentoVisitante]);


        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS) + consulta;

        this.global.getGenerico(url).subscribe(
          data => {
            if (data.length !== 0) {
              existencia = true;
              this.habilitarDeshabilitarNavegador('CONSULTA');
              this.getFiltroBusqueda(this.numeroSerial);
              this.numeroSerial = '';
              this.alertService.generateAlertError(ConstantesService.ACTIVO_EXITENTE_EN_SISTEMA, '');
            } else {
              this.alertService.generateAlertSuccess(ConstantesService.ACTIVO_NO_EXITENTE_EN_SISTEMA, '');
            }
            this.spiner.hide();
          }, err => {
            this.cathException('No es posible validar existencia de numero serial', err);
          }
        );

        return existencia;
      }
    }
  }


  getConfirmationModalResponse(event) {

    if (event[0]) {
      let marcaMayuscula='';
      marcaMayuscula=this.marca.toUpperCase();
      const activoFijoVisitanteDTO = new ActivoFijoVisitanteModel();
      const activoPK = new HisActivoFijoVisitantePK();
      const hisActivoFijoVisitanteDTO = new HisActivoFijoVisitanteModel(activoPK);
      const resp: ContenedorActivoFijoVisitanteModel =
        new ContenedorActivoFijoVisitanteModel(activoFijoVisitanteDTO, hisActivoFijoVisitanteDTO);
      resp.activoFijoVisitanteDTO.numeroSerial = this.numeroSerial;
      resp.activoFijoVisitanteDTO.marca = marcaMayuscula;
      if (this.banderaTipoActivoInput) {
        resp.activoFijoVisitanteDTO.tipoTecnologia = this.tipoActivoFijoInput;
      } else {
        resp.activoFijoVisitanteDTO.tipoTecnologia = this.tipoActivoFijo;
      }
      resp.activoFijoVisitanteDTO.descripcion = this.observaciones;
      resp.activoFijoVisitanteDTO.estado = DominiosService.ESTADO_ACTIVO_FIJO_INGRESADO;
      resp.hisActivoFijoVisitanteDTO.sede = this.sede;
      //resp.hisActivoFijoVisitanteDTO.hisActivoFijoVisitantePK.fechaIngresoActivo = new Date();
      this.respuesta.emit(resp);
      this.obtenerMarcasActivoFijo();
      if(!this.listaMarcas.find(marca => marca === marcaMayuscula)){
        this.registrarNuevaMarca(marcaMayuscula);
      }      
      this.reiniciarFormulario();
    }
  }

  registrarNuevaMarca(marca: string){
    let detalleDominioP : DetalleDominioPK= new DetalleDominioPK(marca,'MarcaActivoFijo');
    let detalleDominio : DetalleDominio=new DetalleDominio(detalleDominioP);
    detalleDominio.valor=marca;
    detalleDominio.estado=1;
    this.spinner.show();
    const serviceProvider = 'ObtenerDominio';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    this.global.postGenerico(url, detalleDominio).subscribe(
      data => {
        // let a: Element =  document.getElementsByClassName('btn-auxiliar').item(0).
        this.obtenerMarcasActivoFijo();
        this.spinner.hide();
      }, err => {
        this.catchException(err);
      }
    );
  }

  reiniciarFormulario() {
    this.numeroSerial = '';
    this.auto.clear();
    this.auto.close();
    this.tipoActivoFijo = '';
    this.sede = '';
    this.observaciones = '';
    this.tipoActivoFijoInput = '';
  }

  onSelect(item: any) {

    this.selectedItem = item;
  }

  onInputChangedEvent(val: string) {

    this.inputChanged = val;
  }

  ingresarElemento() {
    this.spiner.show();


    const elemento = {
      fechaIngreso: this.funcionario.fechaSalidaActivo,
      idUsuarioSia3: this.funcionario.usuarioSIA3,
      numeroIdFuncionario: this.funcionario.numeroIdFuncionario,
      regIngSalActivoFijoPK: {
        fechaSalida: this.funcionario.fechaSalidaActivo,
        idActivo: this.funcionario.idActivo
      },
      sede: this.sede,
      tipoIdFuncionario: this.funcionario.tipoIdFuncionario
    };

    const serviceProvider = 'RegistroActivoFijo';
    const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);

    this.global.putGenerico(url, elemento)
      .subscribe(data => {
        this.spinner.hide();
        this.alertService.generateAlertSuccess('Ingreso del elemento registrado con éxito', '');
      }, error => {
        this.catchException(error.error);
      });
  }

  buscarActivoFijo(event: any) {
    this.busqueda.emit(event);
  }

  FiltroActivoSeleccionado(event: any) {


    this.activoSeleccionado.emit(event);

  }

  catchException(error) {
    this.spinner.hide();
    this.alertService.generateAlertError(error.message, 'Error');
  }

  getFiltroBusqueda(event) {
    this.busqueda.emit(event);
  }

  onChangeSearch(event){
    this.marca= event;
    this.habilitarButtonEntrada();
    this.auto.close();
  }
  
  /**
   * 
   */
  selectEvent(event){
    this.marca= event;
    this.habilitarButtonEntrada();
  }

  clearEvent(event){
    this.marca = event;
    this.habilitarButtonEntrada();    
  }
  
  handlerTipoActivo(event){
    this.tipoActivo.emit(event);
  }

  handlerSede(event){
    this.sedeSeleccionada.emit(event);
  }

  onFocused(event){
    this.auto.close();
  }

  prueba(){
    this.auto.close();
  }

}
